export default "__VITE_ASSET__nAQZipzz__"